import styled from '@emotion/styled';
import MenuRoundedIcon from '@mui/icons-material/MenuRounded';
import SearchRoundedIcon from '@mui/icons-material/SearchRounded';
import WindowSharpIcon from '@mui/icons-material/WindowSharp';
import {
  alpha,
  IconButton,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { SettingsIcon } from 'components/shared/SettingsIcon/SettingsIcon';
import { useAtom } from 'jotai';
import {
  isMobileBurgerMenuOpenAtom,
  isSidebarOpenAtom,
  selectedCategoryDataAtom,
  selectedMobileBurgerTabDataAtom,
  selectedRouteTitleAtom,
} from 'store/private/layout/layoutAtoms';

import HeaderLogo from '../../HeaderLogo/HeaderLogo';
import { PageTemplateActions } from '../../PageTemplateActions/PageTemplateActions';
import { fluidSidebarWidth, staticSidebarWidth } from '../../Sidebar/Sidebar';

export const TemplateTitleBar = props => {
  const theme = useTheme();
  const isBelowTablet = useMediaQuery(theme.breakpoints.down('md'));

  const [selectedRouteTitle] = useAtom(selectedRouteTitleAtom);
  const [selectedCategoryData, setSelectedCategoryData] = useAtom(
    selectedCategoryDataAtom,
  );
  const [selectedMobileBurgerTabData, setSelectedMobileBurgerTabData] = useAtom(
    selectedMobileBurgerTabDataAtom,
  );
  const [isMobileBurgerMenuOpen, setIsMobileBurgerMenuOpen] = useAtom(
    isMobileBurgerMenuOpenAtom,
  );

  const [isSidebarOpen] = useAtom(isSidebarOpenAtom);

  const onClickWindows = () => {
    // setIsMobileBurgerMenuOpen(true);
    // const d = {
    //   id: 'windows',
    //   name: 'windows',
    //   icon: <WindowSharpIcon />,
    //   label: <>&nbsp;</>,
    // };
    // setSelectedMobileBurgerTabData(d);
    // setSelectedCategoryData(d);
  };

  const onClickMenu = () => {
    setIsMobileBurgerMenuOpen(true);
    setSelectedMobileBurgerTabData({ ...selectedCategoryData });
  };

  if (isBelowTablet) {
    return (
      <MobileTitleBar>
        <MobileIconButton onClick={onClickWindows}>
          <WindowSharpIcon />
        </MobileIconButton>
        <MobileIconButton onClick={onClickMenu}>
          <MenuRoundedIcon />
        </MobileIconButton>
        <LogoContainer>
          <HeaderLogo />
        </LogoContainer>
      </MobileTitleBar>
    );
  } else {
    return (
      <TitleBar>
        <PageTemplateActions />
        <LogoContainer open={isSidebarOpen}>
          <HeaderLogo />
        </LogoContainer>
      </TitleBar>
    );
  }
};

const MobileTitleBar = styled.header`
  width: 100%;
  height: 44px;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  z-index: 10;
`;

const AppLogoBox = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const AppLogo = styled.img`
  width: 74px;
`;

const TitleBar = styled.header`
  width: 100%;
  height: 40px;
  display: flex;
  padding-inline: 3px;
  position: relative;
  justify-content: space-between;
  align-items: center;
  z-index: 10;
`;

const Title = styled(Typography)`
  direction: rtl;
  font-family: 'Yekan-Bold';
  text-align: right;
  max-width: calc(100% - 360px);
  ${({ theme }) => ({
    fontSize: theme.typography.h5.fontSize,
    fontWeight: 600,

    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  })}
`;

const LogoContainer = styled('div')(({ theme, open }) => ({
  position: 'fixed',
  right: open
    ? `calc(50% + ${fluidSidebarWidth / 2}px)`
    : `calc(50% + ${staticSidebarWidth / 2}px)`,
  transform: 'translateX(50%)',
  top: 0,
  [theme.breakpoints.down('md')]: {
    top: '0',
    right: '50%',
  },
}));

const MobileIconButton = styled(IconButton)`
  margin-top: 1px;
`;
